import { ComponentBread, ComponentHeader, StyledCreate } from "@components";
import { PATH_ADD_CLINIC, PATH_CLINIC } from "@configs";
import { ClinicForm } from "@modules/clinic";
import { useClinicDetail } from "@utils";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";

export const PageCreateClinic = () => {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation();
  const { data: clinic } = useClinicDetail(id);

  const data = [
    {
      title: <a href={PATH_CLINIC || ""}>Clinic</a>,
    },
    {
      title: <a href={PATH_ADD_CLINIC || ""}>Add Clinic</a>,
    },
  ];

  return (
    <>
      <ComponentHeader title={t("page.add_clinic")} />
      <StyledCreate>
        <ComponentBread pages={data} />
        <ClinicForm clinic={clinic} />
      </StyledCreate>
    </>
  );
};
